<template>
    <div>
        <base-loading :visible="isLoading" />
        <base-modal :isOpen="isOpen" :title="$t('range') | capitalize" @close="$emit('close')">
            <!-- Body -->
            <template #body>
                <vs-row class="mb-4">
                    <vs-col vs-w="6" class="pr-1">
                        <vs-input type="number" :label="$t('start_hour_hrs') | capitalize" :placeholder="$t('start_hour') | capitalize" v-model="startHour"
                            class="w-full " />
                    </vs-col>
                    <vs-col vs-w="6" class="pl-1">
                        <vs-input type="number" :label="$t('end_hour_hrs') | capitalize" :placeholder="$t('end_hour') | capitalize" v-model="endHour"
                            class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input type="number" label="Pallet (USD)" :placeholder="$t('price') | capitalize" v-model="palletPrice"
                            class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input type="number" label="Box (USD)" :placeholder="$t('price') | capitalize" v-model="boxPrice"
                            class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input type="number" label="Bulk (USD)" :placeholder="$t('price') | capitalize" v-model="bulkPrice"
                            class="w-full" />
                    </vs-col>
                </vs-row>
            </template>

            <!-- Footer -->
            <template #footer>
                <vs-button color="danger" type="border" @click="$emit('close')"> {{ $t('cancel') | capitalize }}
                </vs-button>
                <vs-button color="danger" @click="handleSubmit()"> {{ $t('submit') | capitalize }} </vs-button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseModal from '@/views/app/components/modals/BaseModal.vue'
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';

import request from '../request'
export default {
    name: 'RangeModal',
    components: { BaseModal, BaseLoading },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        isEditing: {
            type: Boolean,
            default: false
        },
        client: {
            type: [String, Number],
            default: null
        },
        item: {
            type: Object,
            default: () => ({ id: '', startHour: '', endHour: '', palletPrice: '', boxPrice: '', bulkPrice: '' })
        }
    },
    data() {
        return {
            id: '',
            startHour: '',
            endHour: '',
            palletPrice: '',
            boxPrice: '',
            bulkPrice: '',
            isLoading: false
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.resetForm()
                if (this.isEditing) {
                    this.id = this.item.id
                    this.startHour = this.item.startHour
                    this.endHour = this.item.endHour
                    this.palletPrice = this.item.palletPrice
                    this.boxPrice = this.item.boxPrice
                    this.bulkPrice = this.item.bulkPrice
                }
            }

        }
    },
    methods: {
        formatAmount(value) {
            return Number(value).toFixed(2);
        },
        resetForm() {
            this.id = ''
            this.startHour = ''
            this.endHour = ''
            this.palletPrice = ''
            this.boxPrice = ''
            this.bulkPrice = ''
        },
        handleSubmit() {
            if (this.isEditing) {
                this.updateRange()
            } else {
                this.addRange()
            }
        },
        addRange() {
            const payload = {
                client_id: this.client,
                start_hour: this.startHour,
                end_hour: this.endHour,
                bulk_price: this.bulkPrice,
                pallet_price: this.palletPrice,
                box_price: this.boxPrice
            }
            this.isLoading = true
            request.addRange(payload)
                .then(response => {
                    //console.log(response)
                     this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Added.'
                    })
                    this.isLoading = false
                    this.$emit('close')
                    this.$emit('updated')

                })
                .catch(response => {
                    //console.log(response)
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'warning',
                        title: 'Oops!',
                        text: 'Failed to add the item'
                    })
                })

        },
        updateRange() {
            const payload = {
                id: this.id,
                client_id: this.client,
                start_hour: this.startHour,
                end_hour: this.endHour,
                bulk_price: this.bulkPrice,
                pallet_price: this.palletPrice,
                box_price: this.boxPrice
            }
            this.isLoading = true
            request.updateRange(payload)
                .then(response => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Updated.'
                    })
                    this.isLoading = false
                    this.$emit('close')
                    this.$emit('updated')
                    //console.log(response)
                })
                .catch(response => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'warning',
                        title: 'Oops!',
                        text: 'Something went wrong during the update.'
                    })
                    //console.log(response)
                })
        }
    }
}

</script>

<style scoped></style>
